import StoreblocksAlert, {
  Props as StoreblocksAlertProps,
} from "@storeblocks/alert";

import { SystemIcon } from "@storeblocks/icon";
import StoreblocksInlineAlert from "@storeblocks/inline-alert";
import { isDefined } from "Utils/functions";
import React from "react";
import { AlertType } from ".";
import { InlineP } from "../AccessibleCallUsMessage/styled";
import { useAlertReport } from "./alertHooks";
import { SimpleAlertDesc, SimpleAlertTitle, SimpleInfoAlert } from "./styled";

export interface Props extends Omit<StoreblocksAlertProps, "variant"> {
  type?: StoreblocksAlertProps["variant"];
  alertId?: string;
  alertType?: AlertType;
  noReporting?: boolean;
  marginBottom?: string;
  marginTop?: string;
}

/**
 * Renders an alert based on @storeblocks/alert.
 */
export const Alert = ({
  type = "info",
  ...rest
}: Props): React.ReactElement => {
  useAlertReport({ ...rest });

  const { title, children, description, ...attrs } = rest;

  if (!isDefined(description) && !isDefined(children)) {
    return <StoreblocksInlineAlert {...attrs} variant={type} title={title} />;
  }

  return (
    <StoreblocksAlert {...attrs} variant={type} title={title}>
      {description && (
        <>
          <InlineP>{description}</InlineP>
          <br />
        </>
      )}
      {children}
    </StoreblocksAlert>
  );
};

/**
 * Renders an alert based on our own custom implementation.
 */
export const SimpleAlert = ({
  title,
  description,
}: {
  title: string;
  description: string;
}): React.ReactElement => {
  useAlertReport({ title, description });

  return (
    <SimpleInfoAlert>
      <SystemIcon name="alert" size={24} />
      <div>
        <SimpleAlertTitle className="bold">{title}</SimpleAlertTitle>
        <SimpleAlertDesc style={{ margin: 0 }}>{description}</SimpleAlertDesc>
      </div>
    </SimpleInfoAlert>
  );
};
